import { render, staticRenderFns } from "./WorkloadView.vue?vue&type=template&id=fae2142a&scoped=true&"
import script from "./WorkloadView.vue?vue&type=script&lang=ts&"
export * from "./WorkloadView.vue?vue&type=script&lang=ts&"
import style0 from "./WorkloadView.vue?vue&type=style&index=0&id=fae2142a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae2142a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
